export const trainStationCodeMap = new Map<string, string>([
    ["STP", "London Saint Pancras"],
  ]);
  